import React from "react";
import { Image, VStack } from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";

import { NotificationPrototype } from "./NotificationPrototype";

import not_allowed from "assets/not_allowed.svg";

const NotAllowedNotification = () => {
  return (
    <NotificationPrototype>
      <VStack spacing={6}>
        <Image
          maxH="400px"
          src={not_allowed}
          alt="Zdjęcie - niedostępna strona"
        />
        <ChakraText fontSize="3xl">Strona niedostępna</ChakraText>
      </VStack>
    </NotificationPrototype>
  );
};

export { NotAllowedNotification };
